import React, { Profiler } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import { initConsoleLogger } from "./utils/loggerInit";
import { initializeNetworkInterceptors } from "./utils/networkInterceptors";
import AuthenticatedApp from "./AuthenticatedApp";
import { MantineProvider, Modal } from "@mantine/core";
import { UserContextProvider } from "./contextapi/UserContext";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store";
import { app } from "./firebase/FirebaseCredential";
import {
  getToken,
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  ReCaptchaV3Provider,
} from "firebase/app-check";
import { PersistGate } from "redux-persist/integration/react";
import { ChatProvider } from "./Components/ChatComponent/context/ChatContext";
import "./Components/ClassesComponent/fullcalendar-mantine.css";
import { getApp } from "firebase/app";
import { appTheme } from "./theme";

// Fire network safety net immediately after imports
initializeNetworkInterceptors();



// const onRenderCallback: React.ProfilerOnRenderCallback = (
//   id, // the "id" prop of the Profiler tree that has just committed
//   phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
//   actualDuration, // time spent rendering the committed update
//   baseDuration, // estimated time to render the entire subtree without memoization
//   startTime, // when React began rendering this update
//   commitTime // when React committed this update
// ) => {
//   // console.log({
//   //   id,
//   //   phase,
//   //   actualDuration,
//   //   baseDuration,
//   //   startTime,
//   //   commitTime,
//   // });
//   // console.log(`[Profiler] ${id} - ${phase} (Duration: ${actualDuration}ms)`);
// };
if (process.env.NODE_ENV === "development") {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  // Initialize console logger (suppress logs based on Remote Config/localStorage)
  initConsoleLogger();
}

// Optional: expose for console testing
// (window as any).appCheck = appCheck;

// // Test retrieving token
// getToken(appCheck, /* forceRefresh */ true)
//   .then((tokenResult) => {
//     console.log("App Check token:", tokenResult.token);
//   })
//   .catch((err) => {
//     console.error("Error getting App Check token:", err);
//   });
// console.log("Firebase App initialized", process.env.REACT_APP_RECAPTCHA_SITE_KEY);

// Register service worker for Firebase Cloud Messaging
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      // console.log("Service Worker registered:", registration);
    })
    .catch((err) => {
      console.error("Service Worker registration failed:", err);
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <UserContextProvider>
            {/* <Profiler id="root" onRender={onRenderCallback}> */}
            <MantineProvider theme={appTheme}>
              <ModalsProvider>
                <ChatProvider>
                  <Notifications position="top-right" />
                  <AuthenticatedApp />
                  <ToastContainer />
                </ChatProvider>
              </ModalsProvider>
            </MantineProvider>
            {/* </Profiler> */}
          </UserContextProvider>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
// color palette karthik
// brand: [
//                   "#ffe5e7", // [0] lightest
//                   "#fbbdc2", // [1]
//                   "#f8959d", // [2]
//                   "#f56d78", // [3]
//                   "#f24553", // [4]
//                   "#f896a2",
//                   "#f2354b",
//                   "#f2354b",
//                   "#f2354b",
//                   "#f2354b",
//                 ],
// color palette
// brand: [
//   "#ffe5e7", // [0] lightest
//   "#fbbdc2", // [1]
//   "#f8959d", // [2]
//   "#f56d78", // [3]
//   "#f24553", // [4]
//   "#f2354b", // [5] base color
//   "#d12f43", // [6]
//   "#b0293a", // [7]
//   "#902331", // [8]
//   "#701d28", // [9] darkest
// ],
